import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label']

  async copy(event) {
    const url = event.currentTarget.dataset.copyLinkUrl

    if (!url) {
      return
    }

    try {
      await this.writeToClipboard(url)
      this.showLabel('Copied')
    } catch {
      this.showLabel('Copy failed')
    }
  }

  async writeToClipboard(url) {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(url)
      return
    }

    const input = document.createElement('textarea')
    input.value = url
    input.setAttribute('readonly', '')
    input.style.position = 'fixed'
    input.style.opacity = '0'
    document.body.appendChild(input)
    input.select()

    const copied = document.execCommand('copy')
    input.remove()

    if (!copied) {
      throw new Error('Clipboard access is unavailable')
    }
  }

  showLabel(text) {
    this.labelTarget.textContent = text
    window.setTimeout(() => {
      this.labelTarget.textContent = 'Copy Link'
    }, 2000)
  }
}
